//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createDTGridHost } from "../../dt-plugins/dt-grid/dt-grid.mixin";

export default {
  mixins: [createDTGridHost()],
  mounted() {
    setTimeout(() => {
      console.log({ lazyF: this.lazyF });
      this.lazyF = false;
      console.log({ lazyF: this.lazyF });
    }, 2000);
  },
  data() {
    return {
      lazyF: true,
    };
  },
};
